<template>
	<div class="member-friends">
		<h2 class="level-one-heading mb-5">Vänner</h2>
		<hr>
		<div class="list-settings">
			<toggle-button
				v-model="filter"
				text="Vänner"
				activeValue="accepted"
				sticky
				:counter="acceptedRequests.length"
			/>
			<toggle-button
				v-model="filter"
				text="Väntande Vänförfrågningar"
				activeValue="received"
				sticky
				:disabled="currentUser.id !== user.id || ! receivedRequests.length"
				:counter="receivedRequests.length"
			/>
			<toggle-button
				v-model="filter"
				text="Skickade Vänförfrågningar"
				activeValue="sent"
				sticky
				:disabled="currentUser.id !== user.id || ! sentRequests.length"
				:counter="sentRequests.length"
			/>
		</div>

		<div v-if="filter === 'received'" class="friend-list">
			<template v-if="receivedRequests && receivedRequests.length">
				<friend-card
					v-for="request in receivedRequests"
					:user="user"
					:request="request"
					:key="request.id"
					@update="getFriends()"
				/>
				<div v-if="! receivedRequests.length">
					Du har inga obesvarade vänförfrågningar! :D
				</div>
			</template>
		</div>

		<div v-if="filter === 'accepted'" class="friend-list">
			<friend-card
				v-for="request in acceptedRequests"
				:user="user"
				:request="request"
				:key="request.id"
				@remove="r => removeFriendRequest(r)"
			/>
			<div v-if="! acceptedRequests.length">
				{{ user.username }} har inte lagt till några vänner än!
			</div>
		</div>

		<div v-if="filter === 'sent'" class="friend-list">
			<template v-if="sentRequests && sentRequests.length">
				<friend-card
					v-for="request in sentRequests"
					:user="user"
					:request="request"
					:key="request.id"
					@remove="r => removeFriendRequest(r)"
				/>
				<div v-if="! sentRequests.length">
					Du har inte obesvarade vänförfrågningar! :D
				</div>
			</template>
		</div>
	</div>
</template>

<script>
import waja from 'waja';
import alert from 'alert';
import { t } from 'datastore/i18n';
import store from 'datastore';
import { mapState } from 'vuex';
import { urlFormat } from 'utils';
import memberUtils from 'utils/member';
import { friendStatus } from 'staticData';

export default {
	store,
	props: ['user'],
	data () {
		return {
			friends: [],
			memberUtils,
			filter: 'accepted',
		};
	},
	beforeRouteEnter (to, frm, next) {
		waja.get('user/' + to.params.id + '/friends')
			.on('success', res => {
				next(vm => {
					vm.friends = res.data;
				});
			}).on('error', (e) => {
				next('/');
			}).go();
	},
	methods: {
		urlFormat,
		tm: t.prefix('MEMBER'),
		getFriends() {
			if (this.user && this.user.id) {
				waja.get('user/' + this.user.id + '/friends')
					.on('success', res => {
						this.friends = res.data;
					}).go();
			}
		},
		removeFriendRequest (request) {
			waja.post('friend-request/'+request.id+'/remove')
				.on('success', res => {
					this.getFriends();
					alert('Din vänstatus har uppdaterades.');
				}).go();
		},
	},
	computed: {
		acceptedRequests() {
			return this.friends.filter(f => f.status === friendStatus.ACCEPTED).sort((f1, f2) => {
				if (f1.latestActivity && f2.latestActivity) {
					return f1.latestActivity.datetime < f2.latestActivity.datetime ? 1 : -1;
				} else {
					return f1.id - f2.id;
				}
			});
		},
		receivedRequests() {
			return this.friends.filter(f => f.status === friendStatus.RECEIVED);
		},
		sentRequests() {
			return this.friends.filter(f => f.status === friendStatus.SENT);
		},
		...mapState({
			currentUser: state => state.user,
		}),
	}
};
</script>
